export default function setToSession(name, value, inMin) {
    let expiredAt = new Date(new Date().getTime() + (60000 * inMin));
    let obj = {
        value: value,
        expiredAt: expiredAt.toISOString()
    }
    sessionStorage.setItem(name, JSON.stringify(obj));
}